import React from 'react'
import { Button as MaterialUIButton } from '@mui/material'

export const Button = props => {
    return <MaterialUIButton variant="contained" {...props} />
}
